import React from 'react'

const SettingContextStep4 = React.createContext({})
export const SettingProviderStep4 = SettingContextStep4.Provider
export default SettingContextStep4